(function () {
	'use strict';

	angular
		.module('components.window', ['ngAnimate', 'components.draggable'])
		.directive('window', window)
		.run(['$templateCache', function ($templateCache) {
			$templateCache.put(
				'/tmpls/window',
				'<div class="floating-window" id="{{ id }}"' +
				'draggable="{handle: \'div.panel-heading\',opacity: 0.5,scroll: false, containment: \'#mapa-sistema\'}">' +
				'<div class="{{ panel }} panel-primary borda-cinza">' +
				'<div class="panel-heading cursor-move panel-cinza text-center bold" id="windowHeading">' +
				'<span class="pull-left">' +
				// '<a type="button" id="windowMinimizeBtn" class="btn btn-default btn-xs" ng-click="minimize()">' +
				// '<span class="glyphicon" ng-class="{false: \'glyphicon-chevron-up\',true: \'glyphicon-chevron-down\'}[minimized]"></span>' +
				// '</a>' +
				'</span>' +
				'<span style="font-size: 18px;">{{ title2 }}</span>' +
				'</div>' +
				'<div id="windowBody">' +
				'<div class="panel-body" id="windowBodyContent" ng-transclude></div>' +
				'</div></div></div>');
		}]);

	window.$inject = ['$animate'];

	function window($animate) {

		return {
			restrict: 'E',
			transclude: true,
			replace: true,
			templateUrl: '/tmpls/window',
			scope: {
				id: '@id',
				title: '@title',
				title2: '@title2',
				panel: '@panel'
			},
			link: link
		};

		function link(scope, el, attr) {
			scope.minimized = false;

			if (!scope.panel) {
				scope.panel = 'panel';
			}

			/** Methods **/
			scope.minimize = function () {
				scope.minimized = !scope.minimized;

				if (angular.equals(scope.minimized, true)) {
					$animate.addClass(el, 'minimize');
				} else {
					$animate.removeClass(el, 'minimize');
				}
			}; // end minimize
		} // end link

	} // end resizeable
})();
